import { apiRequest } from './client.js';
import {
  JOB_QUANTITY_PATH,
  jobQuantityByAssignmentPath,
  jobQuantityPath,
  jobQuantityStatingPath,
  type JobQuantityDetail,
  type JobQuantityStating,
  type JobQuantityVerification,
  type ReviseJobQuantityInput,
  type SubmitJobQuantityInput,
} from '../../../shared/contracts/job-quantity.js';

/**
 * Job quantity verification. The contract (types, paths, the billable
 * arithmetic) lives in shared/contracts/job-quantity, which the phone reads
 * too; these are the web's calls on it.
 */
export type {
  JobQuantityDetail,
  JobQuantityRevision,
  JobQuantityStating,
  JobQuantityVerification,
  ReviseJobQuantityInput,
  SubmitJobQuantityInput,
} from '../../../shared/contracts/job-quantity.js';

export async function submitJobQuantity(
  token: string,
  body: SubmitJobQuantityInput,
): Promise<JobQuantityVerification> {
  return apiRequest<JobQuantityVerification>(JOB_QUANTITY_PATH, { method: 'POST', token, body });
}

export async function reviseJobQuantity(
  token: string,
  verificationId: string,
  body: ReviseJobQuantityInput,
): Promise<JobQuantityVerification> {
  return apiRequest<JobQuantityVerification>(jobQuantityPath(verificationId), {
    method: 'PUT',
    token,
    body,
  });
}

export async function getJobQuantity(
  token: string,
  verificationId: string,
): Promise<JobQuantityDetail> {
  return apiRequest<JobQuantityDetail>(jobQuantityPath(verificationId), { token });
}

export async function getJobQuantityStating(
  token: string,
  assignmentId: string,
): Promise<JobQuantityStating> {
  return apiRequest<JobQuantityStating>(jobQuantityStatingPath(assignmentId), { token });
}

export async function findJobQuantityByAssignment(
  token: string,
  assignmentId: string,
): Promise<JobQuantityDetail | null> {
  return apiRequest<JobQuantityDetail | null>(jobQuantityByAssignmentPath(assignmentId), { token });
}